<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Date of Inspection" oneline>{{ Item.created_at ? $options.filters.formatDatebyMoment(Item.created_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Lift Number" oneline>{{ Item.equipment && Item.equipment.tag_name ? Item.equipment.tag_name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.status }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Number Of Observations" oneline>{{ Item.number_of_infringements }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="BU" oneline>{{ Item.description ? Item.description : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Completed Date" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Completed By" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Project Manager" oneline>{{ Item.project_manager_by && Item.project_manager_by.name ? Item.project_manager_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Acknowledged Date" oneline>{{ Item.acknowledged_at ? $options.filters.formatDatebyMoment(Item.acknowledged_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Acknowledged By" oneline>{{ Item.acknowledged_by && Item.acknowledged_by.name ? Item.acknowledged_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Location" oneline>{{ Item.location }} {{ Item.equipment_type }} {{ Item.equipment_lift_number }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Pending Acknowledgement Date" classLabel="width-210" oneline>{{ Item.pending_acknowledgement_at ? $options.filters.formatDatebyMoment(Item.pending_acknowledgement_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Pending Acknowledgement By" oneline>{{ Item.pending_acknowledgement_by && Item.pending_acknowledgement_by.name ? Item.pending_acknowledgement_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="6">
                    <gofix-text-field classLabel="flex-105" label="Project Name" oneline>{{ Item.project && Item.project.contract_title ? Item.project.contract_title : '' }}</gofix-text-field>
                </b-col>
                <b-col md="6">
                    <gofix-text-field classLabel="flex-105" label="Comment" oneline>{{ Item.comment_so && Item.comment_so.description ? Item.comment_so.description : '' }}</gofix-text-field>
                </b-col>
            </b-row>
            <span v-if="$checkRole(this.$accessModule.safety_inspection_checklist, 'update') && Item && Item.status == 'New'" style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
            </span>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Basic Info" hide-footer :centered="true" v-model="modals.edit.open">
            <b-form class="pb-10">
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            required
                            show-icon-required
                            v-model="modals.edit.data.project">
                        </dropdown-projects>
                        <gofix-form-dropdown
                            label="BU"
                            vLabel="reference_value_text"
                            :reduce="option => option.reference_value_text"
                            v-model="modals.edit.data.description"
                            :options="modals.edit.options.project_descriptions">
                        </gofix-form-dropdown>
                        <dropdown-companies 
                            :project-id="modals.edit.data.project && modals.edit.data.project.id ? modals.edit.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.edit.data.company">
                        </dropdown-companies>
                        <dropdown-user-duties 
                            :project-id="modals.edit.data.project && modals.edit.data.project.id ? modals.edit.data.project.id : null"
                            :company-id="modals.edit.data.company && modals.edit.data.company.id ? modals.edit.data.company.id : null"
                            required
                            show-icon-required
                            role-name="Contractor Supervisor"
                            v-model="modals.edit.data.contractor_supervisor_by">
                        </dropdown-user-duties>
                        <dropdown-locations 
                            :project-id="modals.edit.data.project && modals.edit.data.project.id ? modals.edit.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.edit.data.equipment">
                        </dropdown-locations>
                        <dropdown-user-duties 
                            label="Participating Inspectors"
                            :project-id="modals.edit.data.project && modals.edit.data.project.id ? modals.edit.data.project.id : null"
                            :company-id="modals.edit.data.company && modals.edit.data.company.id ? modals.edit.data.company.id : null"
                            :exclude-id="modals.edit.data.contractor_supervisor_by && modals.edit.data.contractor_supervisor_by.user_id ? modals.edit.data.contractor_supervisor_by.user_id : null"
                            v-model="modals.edit.data.participating_inspector">
                        </dropdown-user-duties>
                    </b-col>
                </b-row> 
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="updateBasicInfo" :loading="modals.edit.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    import DropdownProjects from '../elements/DropdownProjects.vue'
    import DropdownLocations from '../elements/DropdownLocations.vue'
    import DropdownCompanies from '../elements/DropdownCompanies.vue'
    export default {
        name: 'safety-inspection-checklist-detail-info',
        components: {
            DropdownUserDuties,
            DropdownProjects,
            DropdownLocations,
            DropdownCompanies
        },
        data() {
            return {
                modals: {
                    edit: {
                        open: false,
                        loading: false,
                        data: {
                            project: null,
                            equipment: null,
                            company: null,
                            contractor_supervisor_by: null,
                            participating_inspector: null,
                            description: null
                        },
                        options: {
                            project_descriptions: [],
                        }
                    }
                },
                timer: {
                    edit: null,
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: 'SafetyAppController/safetyJob',
            }),
        },
        created() {
            
        },
        methods: {
            /*-- Get Data --------*/
            getProjectDescriptions(){
                let filter = {reference_type: "Safety Project Description"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.modals.edit.options.project_descriptions = response.items;
                    })
            },
            editBacsicInfo() {
                this.getProjectDescriptions();
                this.modals.edit.data = Object.assign(this.modals.edit.data, {
                    project: this.Item.project,
                    equipment: this.Item.location_id ? { 
                        location_id: this.Item.location_id, 
                        name: this.Item.location,
                        equipment_id: this.Item.equipment_id,
                        equipment_lift_number: this.Item.equipment_lift_number,
                        equipment_type: this.Item.equipment_type,
                        id: this.Item.location_id
                    } : null,
                    company: this.Item.supplier_id ? { id: this.Item.supplier_id, name: this.Item.supplier } : null,
                    contractor_supervisor_by: this.Item.contractor_supervisor_by && this.Item.contractor_supervisor_by.id ? {
                        ...this.Item.contractor_supervisor_by,
                        user_id: this.Item.contractor_supervisor_by.id,
                        user_name: this.Item.contractor_supervisor_by.name,
                        user_email: this.Item.contractor_supervisor_by.email,
                    } : null,
                    participating_inspector: this.Item.participating_inspector,
                    description: this.Item.description
                });
                this.modals.edit.open = true;
            },
            updateBasicInfo() {
                if (this.timer.edit) {
                    clearTimeout(this.timer.edit);
                    this.timer.edit = null;
                }
                this.timer.edit = setTimeout(async () => {

                    const validate_fields = [
                        { key: 'project', name: 'Project'},
                        { key: 'company', name: 'Subcontractor'},
                        { key: 'contractor_supervisor_by', name: 'Subcontractor Supervisor'},
                        { key: 'equipment', name: 'Location'},
                    ]

                    const is_validate = this.$validationData(validate_fields, this.modals.edit.data)
                    if(is_validate) return

                    if(this.modals.edit.loading) return;
                    this.modals.edit.loading = true;

                    let objeClone = {
                        project_id: this.modals.edit.data.project.id,
                        location_id: this.modals.edit.data.equipment.location_id,
                        location: this.modals.edit.data.equipment.name,
                        equipment_id: this.modals.edit.data.equipment.equipment_id,
                        equipment_lift_number: this.modals.edit.data.equipment.equipment_lift_number,
                        equipment_type: this.modals.edit.data.equipment.equipment_type,
                        supplier_id: this.modals.edit.data.company && this.modals.edit.data.company.id ? this.modals.edit.data.company.id : null,
                        supplier: this.modals.edit.data.company && this.modals.edit.data.company.name ? this.modals.edit.data.company.name : null,
                        participating_inspector_by_id: this.modals.edit.data.participating_inspector && this.modals.edit.data.participating_inspector.user_id ? this.modals.edit.data.participating_inspector.user_id : null,
                        contractor_supervisor_id: this.modals.edit.data.contractor_supervisor_by && this.modals.edit.data.contractor_supervisor_by.user_id ? this.modals.edit.data.contractor_supervisor_by.user_id : null,
                        description: this.modals.edit.data.description,
                    };
                    
                    this.$store.dispatch("SafetyAppController/updateSafetyInspectionItem", { id: this.Item.id, data: objeClone })
                    .then(response => {
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.$emit("reloadItem");
                        this.modals.edit.open = false;
                        this.$alertNotification(this.$notificationV2('editing', 'safe_inspection_checklist'), "success");
                    })
                    .catch(err => {
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    }).finally(() => {
                        this.modals.edit.loading = false;
                    });

                }, 200);
            },
        }
    }
</script>
<style lang="scss">
    .flex-105 {
        flex: 0 0 105px;
    }
</style>